import * as React from "react";
const IconDocs = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.4863 1.99243V5.99243C13.4863 8.20157 15.2772 9.99243 17.4863 9.99243L21.4863 9.99243M3.48633 5.99243L3.48633 17.9924C3.48633 20.2016 5.27719 21.9924 7.48633 21.9924H17.4863C19.6955 21.9924 21.4863 20.2016 21.4863 17.9924V11.6493C21.4863 10.5884 21.0649 9.571 20.3148 8.82086L14.6579 3.164C13.9078 2.41386 12.8903 1.99243 11.8295 1.99243L7.48633 1.99243C5.27719 1.99243 3.48633 3.78329 3.48633 5.99243Z"
      stroke={props.color || "#1C1C2C"}
      strokeWidth={1.5}
      strokeLinejoin="round"
    />
    <path
      d="M7.48633 15.6795H17.4863M7.48633 12.3053H12.4863"
      stroke={props.color || "#1C1C2C"}
      strokeWidth={1.3}
      strokeLinecap="round"
    />
  </svg>
);
export default IconDocs;
